import axios from "axios";
import { Message } from "element-ui";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000, // 请求超时时间
  headers: {
    "Content-Type": "application/json",
  },
});
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    Message.success(error);
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.error("响应错误：", error.response);
    const { status, data } = error.response || {};
    switch (status) {
      case 404:
        Message.error("接口不存在");
        break;
      case 500:
        Message.error("服务器错误");
        break;
      default:
        Message.error(data?.message || "网络错误");
    }
    return Promise.reject(error);
  }
);
export default service;
